varying float vAlpha;

void main()
{
    // Soft circular particle
    float distanceToCenter = distance(gl_PointCoord, vec2(0.5));
    float strength = (1.0 - distanceToCenter * 2.0) * 0.3;
    strength = smoothstep(0.0, 0.5, strength);

    // Very subtle white/gray color for atmospheric effect
    vec3 color = vec3(0.6, 0.65, 0.7);

    gl_FragColor = vec4(color, strength * vAlpha * 0.15);
}
